import { useId, useState } from 'react';
import { kebabCase } from 'lodash';

import { Button } from '@simplywallst/ui-core';
import ChevronRightSmallSolid from '@simplywallst/ui-core/icons/ChevronRightSmallSolid';
import ChevronDownSmallSolid from '@simplywallst/ui-core/icons/ChevronDownSmallSolid';
import { Truncator } from '@/components/Truncator';

type Props = {
  title: string;
  children: React.ReactNode;
};

export const Accordion = ({ title, children }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const panelId = useId();
  const panelTitleId = useId();

  return (
    <div className="grid bg-p-grey-50 rounded-x1">
      <Button
        styleType="passive"
        id={panelTitleId}
        onClick={toggleAccordion}
        data-cy-id={`${kebabCase(title)}-accordion`}
        aria-expanded={isOpen ? 'true' : 'false'}
        aria-controls={panelId}
        // TODO TW - Remove important when we have TW button that can be extended
        className="!h-auto !p-x2"
      >
        <div className="grid grid-cols-[auto_min-content] items-center">
          <div className="text-xs text-left text-softer">{title}</div>

          {isOpen ? (
            <ChevronDownSmallSolid className="w-x3 h-x3 fill-soft" />
          ) : (
            <ChevronRightSmallSolid className="w-x3 h-x3 fill-soft" />
          )}
        </div>
      </Button>

      <Truncator open={isOpen} minHeight={0} animationDuration={0.3}>
        <div
          id={panelId}
          role="region"
          aria-labelledby={panelTitleId}
          aria-hidden={isOpen ? 'false' : 'true'}
        >
          {children}
        </div>
      </Truncator>
    </div>
  );
};
